import { createSelector } from 'reselect';

const BXcurrency = 'pts';

export const BUSINESS_EXTRA = 'BUSINESS_EXTRA';

export const selectAuthFeatureState = (state) => state.auth;

export const selectTokenData = createSelector(selectAuthFeatureState, (state) => state.tokenData);

export const selectAccessToken = createSelector(selectTokenData, (state) => state?.access_token);

export const selectAuthUser = createSelector(selectAuthFeatureState, (state) => state?.user);

export const selectImageUrl = createSelector(selectAuthFeatureState, (state) =>
  state?.user?.ImageUrl ? `${state.user.ImageUrl}?bust=${new Date().getMinutes()}` : null
);

export const selectCompanyConfig = createSelector(
  selectAuthFeatureState,
  (state) => state?.user?.companyCultureConfigurations[0]
);

export const selectCompanyCulture = createSelector(selectAuthFeatureState, (state) => {
  let companyCulture = 'US';
  if (state?.user?.companyCultureConfigurations?.length > 0) {
    const [{ CountryCode }] = state.user.companyCultureConfigurations;
    companyCulture = CountryCode;
  }
  return companyCulture;
});

export const selectDateFormat = createSelector(selectCompanyCulture, (companyCulture) => {
  const dateFormat = 'calendar:dateFormats.' + (companyCulture === 'US' ? 'MMMD' : 'DMMM');
  return dateFormat;
});

export const selectCompanyCurrency = createSelector(selectAuthFeatureState, (state) => {
  let companyCurrency = 'USD';
  if (state?.isBXCurrencyCulture) {
    return BXcurrency;
  }
  if (state?.user?.companyCultureConfigurations?.length > 0) {
    const [{ CurrencyCode }] = state.user.companyCultureConfigurations;
    companyCurrency = CurrencyCode;
  }
  return companyCurrency;
});

export const selectCompanyCurrencyCulture = createSelector(selectAuthFeatureState, (state) => {
  let companyCurrencyCulture = 'en-US';
  if (state?.isBXCurrencyCulture) {
    return BUSINESS_EXTRA;
  }
  if (state?.user?.companyCultureConfigurations?.length > 0) {
    const [{ LanguageCode, CountryCode }] = state.user.companyCultureConfigurations;
    companyCurrencyCulture = LanguageCode + '-' + CountryCode;
  }
  return companyCurrencyCulture;
});

export const selectAadvantageNumber = createSelector(selectAuthFeatureState, (state) => {
  return state?.aadvantageNumber;
});
